import { AccessControlProvider } from "@pankod/refine-core";

export const accessControlProvider = (permissions: string = ''): AccessControlProvider => {
  return {
    can: async({ resource, action, params }) => {
      //console.log(resource, action, params);

      const searchPermission = (p: string) => permissions?.includes(p.toLowerCase()+':index');
      let can = searchPermission(resource);
      /*
      switch(resource) {
        case 'Dashboard':
        case 'dashboard':
          can = true;
      }
      */
      return Promise.resolve({ can });
    },
  };
};
